export default __webpack_public_path__ + "static/media/first_data.46fa89f5.svg";